import React from "react";
import BlockHistoryPage from "./ViewHistory.styles";
import IntlMessages from "@iso/components/utility/intlMessages";
import {EditOutlined, CloseOutlined } from '@ant-design/icons';
import {
  Tabs,
  Timeline,
  Card,
  Popconfirm
} from "antd";
import { useSelector } from "react-redux";

const ViewHistory = (props) => {
  const activePermission = useSelector((state) => state.permission.activePermission);
  const { TabPane } = Tabs;

  const cancelBlockActivity = () => {
    props.cancelModalActivity();
  };

  const renderDeleteHistoryButton = (history) => {
    return (
        (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") && <Popconfirm
          placement="bottomRight"
          title="You are about to delete individual record"
          onConfirm={() => {
            confirmDelete(history);
          }}
          okText="Yes"
          cancelText="No"
          className="delete-button"
        >
        <a className='dlt-cust'>
          {<CloseOutlined />}
        </a>
        </Popconfirm>
      )
  }

  const confirmDelete = (history) =>{

  }

  const renderEditHistoryButton = (history) => {
    return (
      (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") &&
      <a className="edit-cust" onClick={() => showEditHistoryModal(history)}>
        {<EditOutlined />}
      </a>
    )
  }

  const showEditHistoryModal = (history) => {

  }

  return (
    // <BlockHistoryPage
    //   visible={props.visibleHistory}
    //   onCancel={cancelBlockActivity}
    //   title="View History"
    //   footer={[
    //     <Button
    //       key="back"
    //       onClick={cancelBlockActivity}
    //       className="cancel-button"
    //     >
    //       {<IntlMessages id="propertyPage.modal.cancel" />}
    //     </Button>,
    //     <Button key="submit" className="btn-success" type="primary">
    //       {<IntlMessages id="propertyPage.modal.save" />}
    //     </Button>,
    //   ]}
    // >
   <BlockHistoryPage>
    <div >
      <br/>
    
        <Timeline>
          <>
            <Timeline.Item color="green">
              {renderDeleteHistoryButton("value")}
              {renderEditHistoryButton("value")}
              <p>Dummy Content </p>
              <Card title="Title" bordered={true}>
                <p className="card_content">Label</p>
                <b className="card_value">value</b>
              </Card>
            </Timeline.Item>

            <Timeline.Item color="green">
            {renderDeleteHistoryButton("value")}
              {renderEditHistoryButton("value")}
              <p>Dummy Content</p>
              <Card title="Title" bordered={true}>
                <p className="card_content">Label</p>
                <b className="card_value">Value</b>
              </Card>
            </Timeline.Item>
            
          </>
        </Timeline>
        
      </div>
    </BlockHistoryPage>
  );
};

export default ViewHistory;
